import { render } from "./footers.vue?vue&type=template&id=7139e23c&scoped=true"
import script from "./footers.vue?vue&type=script&lang=js"
export * from "./footers.vue?vue&type=script&lang=js"

import "./footers.vue?vue&type=style&index=0&id=7139e23c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7139e23c"],['__file',"src/js/components/footers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7139e23c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7139e23c', __exports__)) {
    api.reload('7139e23c', __exports__)
  }
  
  module.hot.accept("./footers.vue?vue&type=template&id=7139e23c&scoped=true", () => {
    api.rerender('7139e23c', render)
  })

}


export default __exports__